import React, { useEffect, useState } from 'react';
import styled from 'styled-components';

const Wrapper = styled.main`
  height: 100vh;
  overflow-y: auto;
  scroll-snap-type: y mandatory;
  scroll-behavior: smooth;
  -webkit-overflow-scrolling: touch;

  /* 고정 헤더에 가리지 않게 스냅 기준 보정 */
  scroll-padding-top: ${({ header }) => `${header}px`};

  @media (max-width: 768px) {
    /* 모바일에서 답답하면 해제 (필요 없으면 주석) */
    scroll-snap-type: none;
  }
`;

const SnapSection = styled.section`
  /* 헤더만큼 뺀 높이로 섹션 한 화면 꽉 채우기 */
  min-height: ${({ header }) => `calc(100vh - ${header}px)`};
  scroll-snap-align: start;
  scroll-snap-stop: always;

  display: flex;
  flex-direction: column;
  justify-content: center; /* 가운데 배치가 필요하면 유지 */
`;

/**
 * headerSelector: 고정 헤더 DOM 선택자 (기본 '#site-header')
 */
const FullPage = ({ children, headerSelector = '#site-header' }) => {
  const [headerH, setHeaderH] = useState(0);

  useEffect(() => {
    const el = document.querySelector(headerSelector);
    if (!el) return;

    const update = () => {
      const h = Math.ceil(el.getBoundingClientRect().height || 0);
      setHeaderH(h);
    };

    // 최초 측정
    update();

    // 헤더 높이 변화를 실시간 반영 (로고 크기/반응형 등)
    const ro = new ResizeObserver(update);
    ro.observe(el);

    // 윈도우 리사이즈 대응
    window.addEventListener('resize', update);

    return () => {
      ro.disconnect();
      window.removeEventListener('resize', update);
    };
  }, [headerSelector]);

  return (
    <Wrapper header={headerH}>
      {React.Children.map(children, (child, idx) => (
        <SnapSection header={headerH} key={idx}>
          {child}
        </SnapSection>
      ))}
    </Wrapper>
  );
};

export default FullPage;
